import React, { useContext, useState } from "react";

import ClientWorkOrderListingHeader from "./ClientWorkOrderListingHeader";

import ClientWorkOrderTable from "./ClientWorkOrderTable";
import { LayoutContext } from "../../../context/LayoutContext";

const ClientWorkOrderList = () => {
  const { isBannerVisible } = useContext(LayoutContext);
  const [isGenerateInvoiceModalOpen, setIsGenerateInvoiceModalOpen] = useState(false);
  const [selectedWorkOrderIds, setSelectedWorkOrderIds] = useState([]);
  const [selectedEngineer, setSelectedEngineer] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState(null);

  return (
    <div
      className={`bg-[#F6F6F6] sm:fixed stikcy  2xl:w-[95.2%] xl:w-[93.2%] lg:w-[90.6%] md:w-[87.5%] sm:w-[95%] w-full h-screen transition-all ${
        isBannerVisible ? "top-[106px]" : "top-[56px]"
      }`}
    >
      <ClientWorkOrderListingHeader
        selectedWorkOrderIds={selectedWorkOrderIds}
        setIsGenerateInvoiceModalOpen={setIsGenerateInvoiceModalOpen}
        selectedEngineer={selectedEngineer}
        status={selectedStatus}
        currency={selectedCurrency}
      />
      <ClientWorkOrderTable
        setIsGenerateInvoiceModalOpen={setIsGenerateInvoiceModalOpen}
        isGenerateInvoiceModalOpen={isGenerateInvoiceModalOpen}
        setSelectedWorkOrderIds={setSelectedWorkOrderIds}
        selectedWorkOrderIds={selectedWorkOrderIds}
        setSelectedEngineer={setSelectedEngineer}
        selectedEngineer={selectedEngineer}
        setSelectedStatus={setSelectedStatus}
        setSelectedCurrency={setSelectedCurrency}
        selectedCurrency={selectedCurrency}
      />
    </div>
  );
};

export default ClientWorkOrderList;
